import { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";

const Menu = ({ setIsDeactivateStaff, status }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleStaff = () => {
        setIsDeactivateStaff(true);
        setIsOpen(false);
    };

    const actionLabel = status === 1 ? "Deactivate Staff" : "Activate Staff";

    return (
        <div className="relative inline-block" ref={menuRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full hover:bg-gray-200"
            >
                <FiMoreVertical className="text-2xl" />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-60 bg-white border rounded-lg shadow-lg z-50">
                    <ul className="py-2 text-gray-700">
                        <li
                            onClick={handleStaff}
                            className={`px-4 py-2 hover:bg-gray-100 cursor-pointer flex`}  >
                            {actionLabel}
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Menu;